{
  "valid": "Platné"
}
